import { SchedulingTimeModel } from '@swagger-http';
import { Moment } from '@tools/utils';
import { SpotPricePoint } from '.';

const withTimezone = (timezone: string, value?: string) =>
    Moment(value).tz(timezone);

function findSchedule(
    item: SpotPricePoint,
    timezone: string,
    schedulingTimes: SchedulingTimeModel[] | undefined,
) {
    return schedulingTimes?.find((time) =>
        withTimezone(item.x).isBetween(
            withTimezone(timezone, time.start),
            withTimezone(timezone, time.end),
            undefined,
            '(]',
        ),
    );
}

const enhanceItems = (
    group: SpotPricePoint[],
    timezone: string,
    schedulingTimes: SchedulingTimeModel[] | undefined,
): SpotPricePoint[] => {
    return group.map((item) => ({
        ...item,
        z: findSchedule(item, timezone, schedulingTimes),
    }));
};

export const processGroups = (
    groups: Record<string, SpotPricePoint[]>,
    timezone: string,
    schedulingTimes: SchedulingTimeModel[] | undefined,
): Record<string, SpotPricePoint[]> => {
    const updatedGroups: Record<string, SpotPricePoint[]> = {};
    Object.keys(groups).forEach((key) => {
        updatedGroups[key] = enhanceItems(
            groups[key],
            timezone,
            schedulingTimes,
        );
    });
    return updatedGroups;
};
